import script from "./promotionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionPage.vue?vue&type=script&setup=true&lang=ts"

import "./promotionPage.vue?vue&type=style&index=0&id=6ab5c310&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab5c310"]])

export default __exports__